// Training reports (/education-reports). Roles and document names are stored
// values; the Excel file stays Turkish.
const educationReports = {
  page: {
    title: 'Training Reports',
    subtitle: 'How far employees have completed the SOPs and trainings assigned to their role (from the real read confirmations and viewing records).',
  },
  actions: {
    excel: 'Download Table',
    excelHint: 'Download every employee’s SOP and training status as Excel',
  },
  stats: {
    assigned: 'Assigned SOPs / Trainings',
    assignedShort: 'Assigned',
    done: 'Completed',
    doneShort: 'Completed',
    pending: 'Pending',
    pendingShort: 'Pending',
    overdue: 'Past Due',
    overdueShort: 'Past due',
    share: '{{percent}}% of assignments',
  },
  scope: {
    label: 'Scope',
    all: 'SOP + Training',
    SOP: 'SOPs only',
    'Eğitim': 'Trainings only',
  },
  toolbar: {
    search: 'Search by name, surname or role…',
    searchShort: 'Search employees…',
    status: 'Completion status',
    all: 'All',
    overdue: 'With overdue items',
    overdueHint: 'Employees with an unfinished assignment past its due date',
  },
  status: {
    completed: 'Completed',
    inProgress: 'In Progress',
    notStarted: 'Not Started',
  },
  types: {
    sop: 'SOP',
    training: 'Training',
  },
  deadline: {
    late: '{{days}} days late',
    today: 'Due today',
    left: '{{days}} days left',
  },
  columns: {
    name: 'Employee',
    role: 'Role',
    progress: 'Progress',
    status: 'Status',
    sop: 'SOP',
    training: 'Training',
    overdue: 'Overdue',
    email: 'E-mail',
    project: 'Project',
    department: 'Department',
  },
  table: {
    listLabel: 'Employees’ training status',
    empty: 'No training records match the filters',
    rangeOf: 'of {{total}} employees',
    ofTotal: 'out of {{total}} employees',
    jump: 'Go to page',
    noRole: 'No role',
    progress: '{{done}}/{{total}}',
  },
  panel: {
    label: 'Selected employee',
    heading: 'Training status',
    pending: 'Pending',
    completed: 'Completed',
    allDone: 'Everything assigned is completed.',
    noneDone: 'Nothing completed yet.',
    role: 'Role',
    department: 'Department',
    projects: 'Projects',
    email: 'E-mail',
    summary: '{{done}} of {{total}} completed',
    version: 'v{{version}}',
  },
  // Training management (/education-management): employees in the SMO's centers
  smo: {
    title: 'Training Management',
    subtitle: 'SMO: {{name}} · SOP and training status of the employees in the centers you are responsible for.',
    excelHint: 'Download the SOP and training status of the employees in your centers as Excel',
    search: 'Search by name, surname, department, role or project…',
    yourCenters: 'Your centers:',
    note: 'Active employees working on a project in one of your centers are listed. An SOP counts as completed once its read confirmation is given (after passing the quiz); a training once at least 50% of the video is watched.',
    noCenters: 'No centers are assigned to you as SMO',
    stats: {
      centers: 'Your Centers',
      centersShort: 'Centers',
      people: 'Employees in These Centers',
      peopleShort: 'Employees',
      done: 'Completed / Assigned',
    },
  },
  note: 'An SOP counts as completed once its read confirmation is given (after passing the quiz); a training once at least 50% of the video is watched. Only active employees are listed.',
  toast: {
    loadError: 'The training report could not be loaded',
    excelDone: 'Excel file downloaded',
    excelError: 'The file could not be downloaded',
    pageJumpInvalid: 'Please enter a page number between 1 and {{max}}.',
  },
};

export default educationReports;
